<template>
  <v-card-actions class="pa-0">
    <v-spacer></v-spacer>
    <v-btn icon flat small @click="goCondition" class="pa-0 ma-0 mt-1">
      <v-tooltip bottom>
        <v-icon slot="activator" color="primary">keyboard_arrow_right</v-icon>
        <span>Ver condición salarial</span>
      </v-tooltip>
    </v-btn>
  </v-card-actions>
</template>

<script>
export default {
  props: {
    item: Object
  },
  methods: {
    goCondition () {
      this.$router.push({ name: 'detalleCondicion', params: { id: this.item.id } })
    }
  }
}
</script>
